// extracted by mini-css-extract-plugin
module.exports = {"component":"index_component__3KnTE","card":"index_card__z9hud","logo":"index_logo__3QEPb"};